import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {NativeServiceApiProvider} from "../../../services/native-api-provider.service";
import {combineLatest, switchMap, tap, zip} from "rxjs";
import { AuthorizationServiceProvider } from 'src/app/auth_profile/services/authorization-service.provider';
import {V3ExerciseSession, V3ExerciseSessionQuestion} from "../../model/v3/cspa";

@Component({
    selector: 'app-question-set-summary',
    templateUrl: './question-set-summary.component.html',
    styleUrls: ['./question-set-summary.component.scss'],
    standalone: false
})
export class QuestionSetSummaryComponent implements OnInit {

  @Input() session: V3ExerciseSession;
  @Input() uuid: string
  questions: V3ExerciseSessionQuestion[] = []
  private personId: number
  resultState = {
    unknown: 'unknown',
    bad: 'bad',
    poor: 'poor',
    good: 'good'
  };
  exerciseSet: string;
  chapter: string;
  section: string;
  exercise: string;
  path: string

  constructor(private route: ActivatedRoute,
              private provider: NativeServiceApiProvider,
              private router: Router,
              private authServiceProvider: AuthorizationServiceProvider) {}

  ngOnInit() {
    zip(
      this.authServiceProvider.getAuthDetailsService().pipe(
        switchMap( detailsApi =>
          combineLatest([
            detailsApi.getUserRole(),
            detailsApi.getSelfPersonId(),
          ]),
        ),
      ),
      this.route.paramMap
    ).pipe(
      tap(([[role, personId], params]) => {
        this.personId = personId
        this.path = role === "Teacher" ? 'teacher/exercises' : 'student/exercises'

        this.exerciseSet = params.get('exerciseSet');
        this.chapter = params.get('chapter');
        this.section = params.get('section');
        this.exercise = params.get('exerciseNb');
      }),
      switchMap(() => this.provider.cspaV3()),
      switchMap(api => api.getSessionQuestions(this.personId, this.uuid)),
    ).subscribe(questions => {
      this.questions = questions
    })
  }

  recreateSession() {
    this.provider.cspaV3().pipe(
      switchMap(api =>
        api.recreateSession(this.personId, {
          prevSession: {
            id: this.session?.id,
            deviceUUID: this.session?.deviceUUID,
          },
        }),
      ),
    ).subscribe(
      newSession => {
        this.router.navigate(
          [this.path, this.exerciseSet, this.chapter, this.section,
            this.exercise, 'session', newSession.deviceUUID, '1']).then()
      }
    )
  }

  getScore() {
    if (!this.session) {
      return null;
    }
    return Math.round(this.session.score * 100);
  }

  getFractionOfScore(){
    const questionsLength = this.questions.length
    const scoreWage = questionsLength > 0 ? 100/questionsLength : 0
    const numerator = questionsLength > 0 ? (this.getScore()/scoreWage).toFixed() : '0'
    return `${numerator}/${questionsLength}`
  }

  mayCorrect() {
    if (!this.session) {
      return false;
    }
    return this.questions.find( q => !q.isCorrect) != null;
  }

  getQuestionScoreClass(question: V3ExerciseSessionQuestion) {
    if (!question.isAnswered || question.score < 0.5) {
      return 'bad';
    } else if (question.score < 0.95) {
      return 'enough';
    } else {
      return 'perfect';
    }
  }

  getResultState() {
    if (!this.session) {
      return this.resultState.unknown;
    }
    if (this.session.score < 0.5) {
      return this.resultState.bad;
    } else if (this.session.score < 0.95) {
      return this.resultState.poor;
    } else {
      return this.resultState.good;
    }
  }

  getQuestions() {
    return this.questions
  }

  onFinish() {
    this.router.navigate(
      [`../../../../../`],
      {
        relativeTo: this.route,
        queryParamsHandling: 'merge'
      }
    ).then()
  }
}
